// 创建文件en/index.js
const French = {
    rejected: "Refusé",
    my: "Ma",
    today: "Aujourd'hui",
    this_week: "Cette semaine",
    this_month: "Ce mois-ci",
    last_month: "Le mois dernier",
    this_year: "Cette année",
    number_of_people: "Nombre de personnes",
    amount: "Montant",
    enter_username_id_to_search: "Entrer le nom d'utilisateur ID pour rechercher",
    team_list: "Liste d'équipe",
    registration_time: "Heure d'inscription",
    selling_face_value: "Valeur faciale de vente",
    click_for_details: "Cliquez pour plus de détails",
    "agent_login": "Connexion Agent",
    'SignOut': 'Se déconnecter',
    'Contact us': "Contactez-nous",
    'Download our app': "Téléchargez notre application",
    'Download it from': "URL de téléchargement",
    'About Us': "à propos de nous",
    'Gobuy USA was founded in 2012': "Gobuy USA a été fondée en 2012",
    'Customer service': "service client",
    'frequently asked question': "FAQ",
    'Return and exchange policy': "Politique de retour et d'échange",
    'Shipping and distribution': "Distribution et livraison",
    'Contact us by email': "Contactez-nous par email",
    'Privacy Policy and Terms of Use': "Politique de confidentialité et conditions d'utilisation",
    'Privacy Policy': "politique de confidentialité",
    'Terms of use': "conditions d'utilisation",
    'Upload credentials': "Télécharger les informations d'identification",
    'The withdrawal is being processed': "Retrait en cours",
    'Cause of failure': "Raison de l'échec",
    'Your shopping cart is still empty': "Votre panier est toujours vide",
    'Log in to view the items in your cart': "Connectez-vous pour voir les articles dans le panier",
    'Browse around': "Parcourir",
    'Account correlation': "Lié au compte",
    'Order management': "Gestion des commandes",
    'Payment method': "Mode de paiement",
    'Collection address': "Adresse de paiement",
    Category: "Classification",
    "MyCommission": "ma commission",
    "Gross income": "revenu total",
    "Direct commission": "commission directe",
    "Indirect commission": "commission indirecte",
    "Transfer to wallet": "Transfert vers le portefeuille",
    "Tip: The transfer amount must be greater than 10USDT": "Astuce : Le montant du transfert doit être supérieur à 10USDT",
    "transfer": "transfert",
    "commission": "commission",
    "Please enter": "Veuillez entrer",
    'Old Password': "Ancien mot de passe",
    'Change password': "Changer le mot de passe",
    'Amazon GIFT CARD': "Carte cadeau Amazon",
    'High Priced Recycling': "Un recyclage à prix élevé",
    'Data': "date",
    'congratulations': "Félicitations",
    'Obtain': "obtenir",
    'ThankYouForParticipating': "Merci d'avoir participé",

    // navbar"",
    Home: "première page",
    Search: "recherche",
    ShoppingCart: "panier",
    Mine: "le mien",

    // 首页
    // 搜索
    EnterSearchContent: "Saisir le contenu de la recherche",
    'Recent searches': "Recherches récentes",
    'popular searches': "Recherches populaires",
    'Please search': "Veuillez saisir les mots-clés que vous souhaitez rechercher",
    'orderSearch': "Entrez le nom de la commande ou du produit pour rechercher",

    // 语言
    'Language selection': "Sélection de la langue",

    // menu
    Brand: "marque",
    Collect: "collecter",
    Manage: "gérer",
    Order: "Commande",
    Wallet: "portefeuille",
    BlindBox: "boîte aveugle",
    MenuGiftCard: "carte cadeau",
    // HotSale
    HotSale: "Les dernières nouveautés sont en vente...",
    // tabs"",
    TodaysOffer: "Plateforme Préférée",
    'Phone': "téléphone portable",
    'Smart Watch': "montre intelligente",
    'Smart bracelet': "bracelet intelligent",

    // gobuy
    'home.gobuy.title': "Des surprises vous attendent",
    'home.gobuy.periods': "boîte aveugle ronde",
    'home.gobuy.freeze': "Participez au compte à rebours",
    'home.gobuy.drawing': "Démarrer le compte à rebours",
    'home.gobuy.buy': "participer",
    'home.gobuy.isbuy': "Déjà participé",
    USDT: "USDT",
    'home.gobuy.jackpot': "cagnotte",
    Purse: "portefeuille",
    Box: "boîte aveugle",
    'GetAPrize': "Obtenez des prix",
    Discount: "Rabais",
    when: "quand",
    points: "intégral",
    seconds: "Deuxième",
    // MessageBox
    'MessageBox.Tips': "indice",
    'MessageBox.Confirm': "confirmer",
    'MessageBox.Cancel': "Annuler",
    'MessageBox.buy.box': "Etes-vous sûr de vouloir acheter cette boîte aveugle ?",
    // Toast
    'succ': "succès",
    'err': "erreur",
    'box.succeeds': "Achat réussi",
    'box.frozen': "Déjà participé",
    'box.issue': "Une seule boîte aveugle peut être achetée par numéro",

    // 商品列表
    filter: "filtre",
    sales: "Volume des ventes",
    selfOP: "Auto-exploité",
    noMore: "pas plus",
    brand: "marque",
    confirm: "confirmer",
    reset: "réinitialiser",
    ComSor: "Tri complet",
    MostPop: "le plus populaire",
    HighLow: "Prix ​​du haut au bas",
    LowHigh: "Prix ​​de bas en haut",
    SalVol: "volume des ventes",
    NewArr: "Nouvel arrivage",

    // 购物车
    'cart.cart': "panier",
    'cart.edit': "modifier",
    'cart.done': "Finition",
    'home.cart.voucher': "Obtenez des coupons",
    'home.cart.outstock': "en rupture de stock",
    'home.cart.offshelf': "Retiré des étagères",
    'Only': "seulement",
    'left': "individuel",
    'Promotion': "Promotion",
    'cart.all': "Tout sélectionner",
    'cart.total': "total",
    'cart.delete': "supprimer",
    'cart.checkout': "L'addition, s'il vous plaît",

    // 我的
    'Direct': "direct",
    'Indirect': "indirect",
    'MyOrders': "ma commande",
    'ViewAll': "Voir tout",
    'Unpaid': "En attente de paiement",
    'ToShip': "En attente d'expédition",
    'ToReceive': "En attente de réception",
    'ToReview': "En attente d'évaluation",
    // 盲盒
    'MyBlindBox': "Liste des boîtes aveugles",
    'WaitingDraw': "En attendant le tirage au sort",
    'Opened': "Ouvert (réception/retour)",
    // 礼品卡
    'After sale': "Après-vente",
    'GiftCard': "Dossiers de recyclage",
    'RecycleGiftCard': "Recycler les cartes cadeaux",
    'Verifying': "vérifier",
    'Rebuying': "Rachat",
    'Repurchased': "En attente de paiement",
    'Paid': "Le paiement a été effectué",
    // 常用工具
    'CommonTools': "Outils communs",
    'MyWallet': "mon portefeuille",
    'VirtualOrders': "commande virtuelle",
    'Refunds': "Remboursement",
    'MyFriends': "mes amis",
    'ChatList': "liste de discussion",
    'RealNameVerification': "Authentification par nom réel",
    'MyFavorites': "ma collection",
    'Addresses': "Gestion des adresses",
    'MyReviews': "Mon avis",
    'BrowsingHistory': "Parcourir l'historique",
    'Promotions': "promos",
    'StoreManagement': "gestion du magasin",
    'BecomeASeller': "Devenez vendeur",

    // 订单列表
    'SearchPlaceholder': "Entrez le nom du produit de la commande à rechercher",
    All: "tous",
    OrderNo: "Numéro de commande",
    items: "pièces",
    ShippingFee: "fret",
    'Refund in Progress': "Remboursement en cours",
    'Cancel Order': "Annuler la commande",
    'Refund': "Remboursement",
    'Track Shipping': "vérifier la logistique",
    'Confirm Receipt': "confirmer la réception des marchandises",
    'Evaluate': "évaluer",
    'Delete': "supprimer",
    'Pay': "Paiement",
    'MessageBox.delete.order': "Êtes-vous sûr de vouloir supprimer cette commande ?",
    'MessageBox.cancel.order': "Êtes-vous sûr de vouloir annuler cette commande ?",
    'MessageBox.receive.order': "Cette commande a-t-elle été reçue ?",
    // 订单详情
    'Order Details': "Détails de la commande",
    'Pickup Code': "Code de ramassage",
    'Complaint': "plainte",
    'After-Sales': "Après-vente",
    'Gift': "Cadeau",
    'Order Date': "date de commande",
    'Used voucher worth': "Montant du bon utilisé",
    'CNY': "RMB",
    'Payment Method': "Mode de paiement",
    'Total Product Amount': "Montant total du produit",
    'Shipping Fee': "fret",
    'Amount Paid': "Montant payé",
    'Return': "retourner la marchandise",
    // 盲盒列表
    'Pending Draw': "En attente du tirage au sort",
    'Pending Unboxing': "A ouvrir",
    'Unboxed': "Déjà allumé",
    'Collected': "Reçu",
    'Recycled': "Recyclé",
    'Unknown': "inconnu",
    'Claim': "recevoir",
    'Recycle': "Rachat",
    'Unbox': "allumer",
    'MessageBox.recycle.box': "Etes-vous sûr de vouloir recycler cette boîte aveugle ?",
    // 盲盒详情
    'Mystery Box Details': "Détails de la boîte aveugle",
    'Unopened': "Pas allumé",
    'box.opened': "Pas allumé",
    'Claimed': "Reçu",
    'Confirm Claim': "Confirmer la collecte",
    'MessageBox.pick.box': "Êtes-vous sûr de vouloir extraire cette boîte aveugle ?",
    // 盲盒提货
    'Please add address': "Veuillez ajouter l'adresse",
    // 礼品卡列表
    'Face Value Total': "Valeur nominale totale",
    // 礼品卡详情
    'Gift Card Details': "Détails de la carte cadeau",
    'Card number': "numéro de carte",
    'Activation code': "code d'activation",
    'Actual recovery price': "prix réel du recyclage",
    // 礼品卡回收
    'Gift Card Recycling': "Recyclage des cartes cadeaux",
    'Confirm Recycling': "Confirmer le recyclage",
    'Please enter the card number': "Veuillez saisir le numéro de carte",
    'Please enter the activation code': "Veuillez entrer le code d'activation",
    'MessageBox.recycle.gift': "Etes-vous sûr de vouloir recycler cette carte cadeau ?",

    // 我的钱包
    'My Wallet': "mon portefeuille",
    'Available Balance': "solde disponible",
    'Frozen Funds': "geler les fonds",
    'Recharge': "recharger",
    "can": "Peut",
    'Withdraw': "Retirer de l'argent",
    'Withdrawal Accounts': "Retirer le compte",
    // 充值
    'Recharge Details': "Détails de la recharge",
    'Recharge Order No.': "Numéro de commande de recharge",
    'Recharge Amount': "Montant de la recharge",
    'Creation Time': "temps de création",
    'MessageBox.recharge.pop': "Veuillez saisir le montant de la recharge",
    // 付款
    'payment': "Paiement",
    'Order submitted successfully, please select payment method': "Commande soumise avec succès, veuillez sélectionner le mode de paiement",
    'Rechargeable card': "carte rechargeable",
    'Please enter a hash': "Veuillez saisir le hachage",
    'Immediate payment': "Payez maintenant",
    'Wait for the file to load': "Veuillez attendre que le fichier se charge",
    // 提现
    'Withdrawal Details': "Détails du retrait",
    'Withdrawal Amount': "Montant du retrait",
    'Application Time': "Temps de candidature",
    'New Application': "nouvelle demande",
    'Payment Password': "Mot de passe de paiement",
    'New Payment Password': "Nouveau mot de passe de paiement",
    'Recipient Information': "Informations sur le bénéficiaire",
    'Submit': "soumettre",
    'Add Recipient Account First': "Veuillez d'abord ajouter un compte de paiement",
    'Please bind your mobile phone or email first': "Veuillez d'abord lier votre téléphone portable ou votre e-mail",
    // 设置
    'Account Settings': "Paramètres du compte",
    'Change Login Password': "Changer le mot de passe de connexion",
    'Change Payment Password': "Changer le mot de passe de paiement",
    'Log Out': "se déconnecter",
    'Mobile': "téléphone portable",
    'Verification Code': "Le code de vérification",
    'Email': "Mail",
    'New Password': "Nouveau mot de passe",
    'Confirm Password': "Confirmez le mot de passe",
    'Modify': "Réviser",
    'Bind': "obligatoire",
    ' Mobile': "téléphone portable",
    ' Email': "Mail",
    // 资金详情
    'Fund Details': "Détails du financement",
    'Withdrawal Account': "Retirer le compte",
    'Account Type': "Type de compte",
    'USDT Address (TRC20)': "Adresse USDT (TRC20)",
    'Edit': "modifier",
    'Delete': "supprimer",
    'Add New': "Ajouter un nouveau compte",
    'MessageBox.delete.bank': "Êtes-vous sûr de vouloir supprimer ce compte de retrait ?",
    // 登录
    'Login': "Se connecter",
    'Sign Up': "registre",
    'Normal Login': "Connexion normale",
    'Username / Email / Phone Number': "Nom d'utilisateur/e-mail",
    'Enter Phone Number': "Veuillez entrer le numéro de téléphone portable",
    'Enter Email': "Veuillez saisir votre adresse e-mail",
    'Enter SMS Code': "Veuillez saisir le code de vérification SMS",
    'Enter Password': "Veuillez entrer le mot de passe",
    "enter_login_password_for_verification": "Veuillez entrer votre mot de passe de connexion pour la vérification",
    'Forgot Password': "oublier le mot de passe",
    'Third-party Login': "Connexion tierce",
    'Please complete the form': "Veuillez remplir le formulaire",
    'WeChat': "WeChat",
    'Weibo': "Weibo",
    'QQ': "QQ",
    'phone login': "Connexion mobile",
    'Login Expired': "La connexion a expiré",
    'Please enter your phone number first': "Veuillez d'abord entrer votre numéro de portable",
    'Please enter your username/email/phone number': "Veuillez entrer votre nom d'utilisateur/e-mail",
    'Please enter your password': "Veuillez entrer le mot de passe",
    'Password must be at least 6 characters': "Le mot de passe doit contenir au moins 6 caractères",
    'Please enter an 11-digit phone number': "Veuillez saisir votre numéro de téléphone portable à 11 chiffres",
    'Please wait for the file to finish loading': "Veuillez attendre que le fichier soit chargé",
    'send': "envoyer",
    'signUpTips': "Vos données personnelles seront utilisées pour améliorer votre expérience sur l'ensemble du site Web, gérer l'accès à votre compte et à d'autres fins décrites dans notre politique de confidentialité.",

    // 注册
    'Sign Up': "registre",
    'Referrer': "recommandateur",
    'Invitation code': "Code d'invitation",
    'Invite friends': "Inviter des amis",
    'Username': "nom d'utilisateur",
    'Full Name': "vrai nom",
    'Set Password': "Définir le mot de passe",
    'Confirm Password': "Confirmez le mot de passe",
    'Phone Number': "numéro de téléphone",
    'Email': "e-mail",
    'Username: 3-25 chars, letters & numbers': "Nom d'utilisateur : 3 à 25 caractères, lettres et chiffres",
    '6-20 digits/letters/symbols': "6-20 chiffres/lettres/symboles",
    'By clicking sign up, you agree to': "En cliquant pour vous inscrire, vous acceptez",
    'User Agreement': "Contrat d'utilisation",
    'Please check the user agreement': "Veuillez vérifier les conditions d'utilisation",
    'Please enter a username with 3-25 characters': "Veuillez saisir un nom d'utilisateur de 3 à 25 caractères",
    'Enter SMS Verification Code': "Veuillez saisir le code de vérification SMS",
    'Please enter your phone number': "Veuillez entrer votre numéro de portable",
    'Please enter the verification code': "Veuillez entrer le code de vérification",
    'Please enter a 6-digit verification code': "Veuillez saisir le code de vérification à 6 chiffres",
    'Please enter a password with 6-20 characters': "Veuillez saisir un mot de passe de 6 à 20 caractères",
    'Please enter the confirm password': "Veuillez saisir le mot de passe de confirmation",
    'The confirm password does not match the entered password': "Le mot de passe de confirmation ne correspond pas au mot de passe saisi",

    // 密码恢复
    'Password Recovery': "Récupération de mot de passe",
    'Forgot Password': "oublier le mot de passe",
    'Forget.email.tips': "Si votre compte n'est pas encore associé à un numéro de messagerie, veuillez contacter l'administrateur de la plateforme pour récupérer votre mot de passe.",

    // 通知
    'Notification Message': "message de notification",
    'Direct Message': "message privé",
    'System Message': "Messages système",
    'Leave a Message': "message",

    // 配送地址
    'Delivery Address': "adresse de livraison",
    'The store is no longer valid, please edit the delivery address again': "Cette boutique n'est plus valide, veuillez rééditer l'adresse de livraison",
    'Default address': "Adresse par défaut",
    'Add address': "Ajouter une adresse",
    'Edit address': "Modifier l'adresse",
    'MessageBox.delete.address': "Êtes-vous sûr de vouloir supprimer cette adresse ?",
    'name': "Nom",
    'phone': "Numéro de téléphone",
    'district': "district",
    'address': "adresse",
    'default address': "Adresse par défaut",
    'save and use': "Enregistrer et utiliser",
    'save': "sauvegarder",
    'Please select a region': "Veuillez sélectionner une région",
    'Please fill in the recipient name': "Veuillez saisir le nom du destinataire",
    'Name must be 2-15 characters': "Le nom doit comporter entre 2 et 15 caractères",
    'Please fill in the mobile phone number': "Veuillez entrer le numéro de téléphone portable",
    'Please select your location': "Veuillez sélectionner votre emplacement",
    'Please fill in the detailed address': "Veuillez remplir l'adresse détaillée",

    // 浏览历史
    'Browsing History': "Parcourir l'historique",
    'Clear browsing history': "Effacer l'historique de navigation",

    // 推广会员
    'Promotion member': "Promouvoir les membres",
    "“PromotionPoster”": "affiche promotionnelle",
    "MemberName": "Nom du membre",
    "MyAssets": "mes atouts",
    "DistributedAmount": "Montant distribué",
    "NumberOfDistributedProducts": "Attribuer la quantité de produit",
    "DistributedProductAmount": "Montant distribué",
    "MyTeam": "mon équipe",
    "LevelOneMembers": "membre de première classe",
    "LevelTwoMembers": "membre de deuxième niveau",
    "PromotionPoster": "affiche promotionnelle",
    "PromotionMembers": "Promouvoir les membres",
    "PromotionPerformance": "performances promotionnelles",
    "ViewPromotionLink": "Cliquez pour voir le lien de promotion",
    "PromoteViaWeChatQRCode": "Promouvoir via le code QR WeChat",
    "Copy": "copie",
    "BrowserNotSupportedCopyManually": "Votre navigateur ne prend pas en charge la copie directe, veuillez copier manuellement",
    "GiftCardRecoveryTotal": "Nombre total de cartes cadeaux recyclées",
    "TodaysGiftCardRecoveryCount": "Le décompte du recyclage des cartes-cadeaux du jour",
    "RegistrationDate": "Date d'inscription",
    "LastLogin": "dernière connexion",
    "Promotion Commission": "Commission promotionnelle",

    // userinfo 个人信息
    "Personal Info": "informations personnelles",
    "Nickname": "Surnom",
    "Birthdate": "date de naissance",
    "Save": "sauvegarder",
    "CropImage": "Recadrer l'image",
    "UseImage": "Utiliser des images",

    // goodsDetail 商品详情
    "Off": "Rabais",
    "Sold": "vendu",
    "Product": "produit",
    "Comment": "Commentaire",
    "Details": "Détails",
    "ReportViolation": "rapport",
    "Cart": "panier",
    "ChatMessages": "Messages de discussion",
    "MyShop": "mon magasin",
    "MerchantLogin": "Connexion marchand",
    "Share": "partager",
    "ShareTo": "Partager sur",
    "WeChat": "WeChat",
    "Copy": "copie",
    "Poster": "affiche",
    "BrowserNotSupportedCopyManually": "Votre navigateur ne prend pas en charge la copie directe, veuillez copier manuellement",
    "Follow": "se concentrer sur",
    "Unfollow": "Ne plus suivre",
    "PleaseSelectQuantityAndCategory": "Veuillez sélectionner la quantité et la catégorie.",
    "SelectedWithQuantity1": "{spécification} sélectionné, quantité {numéro}.",
    "SelectedQuantity1": "Quantité sélectionnée {numéro}.",
    "SelectedWithQuantity2": "{spécification} sélectionné, quantité {numéro}.",
    "Add to cart": "ajouter au panier",
    "Buy now": "Achetez-le maintenant",
    "Stock": "en stock",
    "Pieces": "pièces",
    "Quantity": "quantité",
    "All": "tous",
    "Good": "Bonnes critiques",
    "Medium": "Note neutre",
    "Bad": "Mauvaise critique",
    // 评论
    "Product review": "avis sur les produits",
    "anonymous": "anonyme",
    "noReviewInfo": "Aucune information de commentaire fournie",
    "Shop Owners Response": "Le commerçant répond",
    "This product has no current reviews": "Il n'y a actuellement aucun avis pour ce produit",
    "Product details": "Détails du produit",
    "shop": "boutique",
    "customerService": "service client",
    "shoppingCart": "panier",
    "addToCart": "ajouter au panier",
    "buyNow": "Achetez-le maintenant",
    "outOfStock": "Le produit sélectionné est actuellement en rupture de stock, désolé !",
    "notAvailable": "Le produit sélectionné n'est plus disponible, désolé !",
    "Store order message": "Nouvelles des commandes en magasin",
    "Confirm the order": "Confirmer la commande",
    "productAmount": "Quantité de produit",
    "discount": "Rabais",
    "shippingFee": "fret",
    "subtotal": "Sous-total du magasin",
    "Submit an order": "Soumettre la commande",
    // 退货
    "refundAdd": "Ajouter un remboursement",
    "back": "retour",
    "refundDescription": "Instructions de remboursement :",
    "proofOfRefund": "Bon de remboursement",
    "use": "utiliser",
}
export default French
